import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
    selectAuthData,
    selectAccountRecoveryData,
    selectAccountRecoveryStatus,
    selectAuthenticatorData,
    selectAuthenticatorStatus,
    selectAuthStatus,
    selectBannerInfo,
    selectError,
    selectErrorAuth,
    selectErrorForgotPwd,
    selectErrorSession,
    selectForgotPwdProgess,
    selectForgotPwdSuccessMsg,
    selectInitStatus,
    selectIsVerified,
    selectAuthVerified,
    selectQRCodeData,
    selectQRCodeStatus,
    selectResendSuccess,
    selectResendSuccessMsg,
    selectStep,
    selectMfaRequired,
    selectLoginSessionTimeout,
    selectValidatePhoneAtLogin,
    selectErrorMagicLinkLogin,
    selectMagicLinkLoginMsg,
    selectMagicLinkVerificationStatus,
    selectErrorMagicLinkVerify
} from '../../../../reducers/login'
import {
    activateAuthenticatorCode,
    authenticate,
    backToAuthenticators,
    backToOptionalAuthenticators,
    backFallbackEnforceMFA,
    backFallbackEnforceMFATwoSteps,
    enrollAuthFactor,
    enrollMFA,
    forgotPassword,
    getAuthenticators,
    getAccountRecovery,
    init,
    loginApp,
    maintenanceBanner,
    qrCodeCannotScan,
    qrCodeCannotScanNext,
    qrCodeNext,
    resendChallenge,
    resetAuthVerified,
    sendChallenge,
    setAuthenticator,
    setDeviceType,
    skipMfaEnrollment,
    verifyAccountRecovery,
    verifyAuthenticatorCode,
    verifyPush,
    onResendAuthChallenge,
    preActivateAlternateAccountRecovery,
    requestLoginMagicLink,
    validatePhoneAtLogin,
    verifyLoginMagicLink
} from '../../../../actions/login'
import { logoutOktaSession, terminateOAGSession } from '../../../../actions/application'
import { selectLogoutStatusOkta, selectLogoutStatusOAG } from '../../../../reducers/application'


const mapStateToProps = createStructuredSelector({
    accountRecoveryData: selectAccountRecoveryData,
    accountRecoveryStatus: selectAccountRecoveryStatus,
    authData: selectAuthData,
    authenticatorData: selectAuthenticatorData,
    authenticatorStatus: selectAuthenticatorStatus,
    authStatus: selectAuthStatus,
    authVerified: selectAuthVerified,
    bannerInfo: selectBannerInfo,
    dataQRCode: selectQRCodeData,
    error: selectError,
    errorAuth: selectErrorAuth,
    errorForgotPwd: selectErrorForgotPwd,
    errorMagicLinkLogin: selectErrorMagicLinkLogin,
    errorMagicLinkVerify: selectErrorMagicLinkVerify,
    errorSession: selectErrorSession,    
    forgotPwdProgress: selectForgotPwdProgess,
    forgotPwdSuccessMsg: selectForgotPwdSuccessMsg,
    initStatus: selectInitStatus,
    isVerified: selectIsVerified,
    logoutStatusOAG: selectLogoutStatusOAG,
    logoutStatusOkta: selectLogoutStatusOkta,
    magicLinkLoginMsg: selectMagicLinkLoginMsg,
    magicLinkVerificationStatus: selectMagicLinkVerificationStatus,
    mfaRequired: selectMfaRequired,
    qrCodeStatus: selectQRCodeStatus,
    resendSuccess: selectResendSuccess,
    resendSuccessMsg: selectResendSuccessMsg,
    sessionTimeout: selectLoginSessionTimeout,
    stepNumber: selectStep,
    validatePhoneAtLogin: selectValidatePhoneAtLogin
})

const mapDispatchToProps = dispatch => {
    return {
        getAccountRecovery: oktaUserId => dispatch(getAccountRecovery(oktaUserId)),
        init: (loginPageLoad, oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean, digitalMarketplaceUrl) => dispatch(init(loginPageLoad, oktaCurrentSession, logoutOAGSessionUrl, cmxClean, secure2Clean, protectedClean, digitalMarketplaceUrl)),
        initAuthenticators: () => dispatch(getAuthenticators()),
        initBanner: () => dispatch(maintenanceBanner()),
        initEnrollAuthFactor: ({ factorType }) => dispatch(enrollAuthFactor({ factorType })),
        initPush: ({ factorId, factorType }) => dispatch(verifyPush({ factorId, factorType })),
        logoutOktaSession: url => dispatch(logoutOktaSession(url)),
        onActivateAuthenticatorCode: ({ factorType, passCode }) => dispatch(activateAuthenticatorCode({ factorType, passCode })),
        onAuthenticate: body => dispatch(authenticate(body)),
        onBackFallbackEnforceMFA: () => dispatch(backFallbackEnforceMFA()),
        onBackFallbackEnforceMFATwoSteps: () => dispatch(backFallbackEnforceMFATwoSteps()),
        onBackToAuthenticators: () => dispatch(backToAuthenticators()),
        onBackToOptionalAuthenticators: () => dispatch(backToOptionalAuthenticators()),
        onEnroll: recoveryType => dispatch(enrollMFA(recoveryType)),
        onEnrollInit: oktaUserId => dispatch(preActivateAlternateAccountRecovery(oktaUserId)),
        onFinish: () => dispatch(loginApp()),
        onForgotPassword: login => dispatch(forgotPassword(login)),
        onQRCodeCannotScan: () => dispatch(qrCodeCannotScan()),
        onQRCodeCannotScanNext: () => dispatch(qrCodeCannotScanNext()),
        onQRCodeNext: () => dispatch(qrCodeNext()),
        onRequestLoginMagicLink: body => dispatch(requestLoginMagicLink(body)),
        onResendAuthChallenge: () => dispatch(onResendAuthChallenge()),
        onResendChallenge: body => dispatch(resendChallenge(body)),
        onSendChallenge: recoveryType => dispatch(sendChallenge(recoveryType)),
        onSetAuthenticator: () => dispatch(setAuthenticator()),
        onSetDeviceType: () => dispatch(setDeviceType()),
        onSkipEnrollment: ({ skipEnrollment }) => dispatch(skipMfaEnrollment({ skipEnrollment })),
        OnValidatePhoneAtLogin: recoveryType => dispatch(validatePhoneAtLogin(recoveryType)),
        onVerifyAccountRecovery: ({ enrollingInMfa, passCode, recoveryType }) => dispatch(verifyAccountRecovery({ enrollingInMfa, passCode, recoveryType })),        
        onVerifyAuthenticatorCode: ({ factorId, factorType, passCode }) => dispatch(verifyAuthenticatorCode({ factorId, factorType, passCode })),
        onVerifyLoginMagicLink: body => dispatch(verifyLoginMagicLink(body)),
        resetAuthVerified: () => dispatch(resetAuthVerified()),
        terminateOAGSession: logoutOAGSession => dispatch(terminateOAGSession(logoutOAGSession))
    }}

export default Component => connect(mapStateToProps, mapDispatchToProps)(Component)